import {
  ContentChild,
  Directive,
  HostListener,
  Input,
  TemplateRef,
} from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { TableService } from './table.service';

@Directive({
  selector: '[appTableMenu]',
  standalone: true,
})
export class TableMenuDirective {
  constructor(public template: TemplateRef<any>) {}
}

@Directive({
  selector: '[appTableContextMenuTrigger]',
  standalone: true,
})
export class TableContextMenuTriggerDirective<T> {
  @Input('appTableContextMenuTrigger')
  row!: T;

  @Input()
  menuEnabled = true;

  @ContentChild(MatMenuTrigger)
  trigger!: MatMenuTrigger;

  constructor(
    protected service: TableService<any>
  ) {}

  @HostListener('contextmenu', ['$event'])
  onRightClick(event: MouseEvent): void {
    if (!this.menuEnabled) {
      return;
    }
    event.preventDefault();

    const { clientX: x, clientY: y } = event;
    this.service.itemSelected = this.row;

    setTimeout(() => {
      const menuElement = document.querySelector(
        '.cdk-overlay-pane'
      ) as HTMLElement;
      if (menuElement) {
        menuElement.style.position = 'fixed';
        menuElement.style.left = `${x}px`;
        menuElement.style.top = `${y}px`;
      }
    }, 0);

    this.trigger.openMenu();
  }
}
